module.exports = __webpack_public_path__ + "static/media/app-icon.f3eee037.png";